import(/* webpackMode: "eager" */ "C:\\Dev\\gogedit_react_nextjs_ts_website\\src\\app\\blog\\page.tsx");
